import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import AuthService from "../../../services/auth.service";
import { useForm } from "react-hook-form";
import { ToastContainer, toast, Zoom } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import ButtonLoading from "../../../components/Loder/buttonLoading";
import AddTimeoutSettingService from "../../../services/settings/AddTimeSettingServices";
// import FullscreenHandler from "../../../components/fullscreen";

const Login = ({setInputValue,setRtl}) => {
  // useFullscreen();

  const { register, handleSubmit, formState: { errors } } = useForm();
  let navigate = useNavigate();
  const form2 = useRef();
  const {
    register: register2,
    handleSubmit: handleSubmit2,
    // reset: reset2,
    formState: { errors: errors2 },
  } = useForm();
  const checkBtn2 = useRef();

  const form = useRef();
  const checkBtn = useRef();
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [forgotpassword, setForgotpassword] = useState(false)
  const [showPassword, setShowPassword] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false); 
  const [redirectTo, setRedirectTo] = useState(null); 

  const handleLogin = data => {
    setLoading(true);
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      AuthService.login(username, password).then(
        (data) => {
          if (data.access) {
            setLoading(false)
            setRtl(false)
            setIsLoggedIn(true);
            sessionStorage.setItem("firstLoginReload", "true");

            if (data.lastlogin === null) {
              // navigate("/changepwd");
              setRedirectTo("/changepwd");
              fetchTimeoutSetting()
            } else {
              // navigate("/");
              setRedirectTo("/");
              fetchTimeoutSetting()
            }
          // navigate('/otpverification',{state:{phone:data.phone_number,lastlogin:data.lastlogin,data:data}})
            toast.success("successfully logedin",
              {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
          }
          else {
            toast.error(`${data.message.error}`,
              {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
            setLoading(false);
            navigate("/login")
          }
        },
      )
    } else {
       toast.error("Something went wrong. Please try again.", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      setLoading(false);
    }
  };

  const fetchTimeoutSetting = async () => {
    try {
      const res = await AddTimeoutSettingService.getTimeoutSetting();
      const timeoutMinutes = parseInt(res.data.timeout) * 60 * 1000;;
      if (!isNaN(timeoutMinutes)) {
        setInputValue(timeoutMinutes)
      }
    } catch (error) {
      console.error('Failed to fetch timeout setting:', error);
    }
  };

  const handleForgotPassword = () => {
    setLoading2(true);
    form2.current.validateAll();

    if (checkBtn2.current.context._errors.length === 0) {
      AuthService.forgotpassword(email).then(
        (data) => {
          if (data.data.success === 1) {
            setLoading2(false)
            setForgotpassword(false)
            setEmail("")
            toast.success("Successfully send email",
              {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
          }
          else {
            toast.error(`${data.data.error}`,
              {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
          }
          setLoading2(false);
        },
      )
    } else {
      setLoading2(false);
    }
  };


  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // useEffect(() => {
  //   if (isLoggedIn && redirectTo) {
  //     navigate(redirectTo);
  //   }
  // }, [isLoggedIn, redirectTo, navigate]);
useEffect(() => {
  if (isLoggedIn && redirectTo) {
    navigate(redirectTo);

    // 🔁 reload only once
    const shouldReload = sessionStorage.getItem("firstLoginReload");
    if (shouldReload) {
      sessionStorage.removeItem("firstLoginReload");
      window.location.reload();
    }
  }
}, [isLoggedIn, redirectTo, navigate]);

  return (
    <section>
      <ToastContainer
        autoClose={2000}
        theme="colored"
        transition={Zoom}
      />
       {/* {isLoggedIn && <FullscreenHandler />} */}
      <div className="page-header section-height-100" style={{ backgroundColor: '#245C7F' }}>
        <div className="container lgfixed" style={{maxWidth:'1350px'}}>
          <div className="row justify-content-center" style={{marginLeft:'-3%' }}>
            <div className="col-xl-4 col-lg-5 col-md-6 d-flex flex-column mx-auto" style={{ backgroundColor: 'white' }}>
              <div className="bg-transparent  mt-5">
                <div className="header pb-0 text-left bg-transparent ">
                  <h4 className="mb-4 text-left" style={{marginLeft:'20px', fontWeight:'bold',fontFamily:'revert'}} >
                    {/* <img 
                      src={process.env.PUBLIC_URL + "/static/images/logoupdate.png"}
                      alt="Athena Fintech"
                    /> */}
                    LOGIN
                    <p style={{color:'#67748e',fontSize:'15px'}}>Welcome to Athena’s SAAS Platform</p>
                  </h4>
                </div>
              </div>
              <div className="bg-transparent mt-2">
                <div className="card-body">
                  {
                    forgotpassword === true ?
                      <Form
                        role="form text-left"
                        method="POST"
                        action="."
                        onSubmit={handleSubmit2(handleForgotPassword)}
                        ref={form2}
                      >
                        <label className="tc">Email</label>
                        <div className="mb-3">
                          <input
                            className="form-control  validate black-text"
                            name="email"
                            type="email"
                            placeholder='Email'
                            value={email}
                            {...register2('email', {
                              onChange: (e) => { setEmail(e.target.value) }, required: "Email is Required",
                              pattern: {
                                value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                message: 'Please enter a valid Email'
                              }
                            })}
                          />
                          <span className="invalid-feedback" >{errors2.email && errors2.email?.message}</span>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                          </div>
                          <div className="row col-md-6">
                            <div className="footer text-right pt-0 px-lg-2 px-1">
                              <span className="mb-4 text-sm mx-auto tc  font-weight-bold cursor-pointer" onClick={() => setForgotpassword(!forgotpassword)}>
                                Login
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="text-center">
                          <button
                            type="submit"
                            name="login"
                            className="btn btn-primary w-100 mt-4 mb-0"
                          >
                            {
                              loading2 === false ? (

                                ('Forgot Password')
                              ) : (
                                <ButtonLoading />
                              )
                            }
                          </button>
                        </div>
                        <CheckButton style={{ display: "none" }} ref={checkBtn2} />
                      </Form>
                      : <> <Form
                        role="form text-left"
                        method="POST"
                        action="."
                        onSubmit={handleSubmit(handleLogin)}
                        ref={form}
                      >
                        <label className="tc">Email</label>
                        <div className="mb-3">
                          <input
                            className="form-control  validate black-text"
                            name="email"
                            type="email"
                            placeholder='Email'
                            value={username}
                            {...register('email', {
                              onChange: (e) => { setUsername(e.target.value) }, required: "Email is Required",
                              pattern: {
                                value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                message: 'Please enter a valid Email'
                              }
                            })}
                          />
                          <span className="invalid-feedback" >{errors.email && errors.email?.message}</span>
                        </div>
                        <label className="tc">Password</label>
                        <div className="mb-3" style={{ position: 'relative' }}>
                          <input
                            className="form-control col-lg-8 validate black-text"
                            name="password"
                            type={showPassword ? 'text' : 'password'}
                            placeholder='Password'
                            value={password}
                            {...register('password', { onChange: (e) => { setPassword(e.target.value) }, required: true })}
                          />
                          <i
                            className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'} eye-icon`}
                            onClick={togglePasswordVisibility}
                            style={{ position: 'absolute', top: '50%', right: '10px', transform: 'translateY(-50%)', cursor: 'pointer' }}
                          ></i>
                          <span className="invalid-feedback"> {errors.password && "Password is Required"}</span>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" />
                              <label class="form-check-label" for="defaultCheck1">
                                Keep me logged in
                              </label>
                            </div>

                          </div>
                          <div className="col-md-6">

                            <div className="footer text-right pt-0 px-lg-2 px-1">
                              <span className="mb-4 text-sm mx-auto tc  font-weight-bold cursor-pointer" onClick={() => setForgotpassword(!forgotpassword)}>
                                Forgot Password?
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="text-center">
                          <button
                            type="submit"
                            name="login"
                            className="btn btn-primary w-100 mt-4 mb-0"
                          >
                            {
                              loading === false ? (

                                ('Log In')
                              ) : (
                                <ButtonLoading />
                              )
                            }
                          </button>
                        </div>
                        <CheckButton style={{ display: "none" }} ref={checkBtn} />
                      </Form>

                      </>

                  }

                </div>
              </div>
              <div className="bg-transparent  mt-7">
                <div className="footer text-center pt-0 px-lg-2 px-1">
                  <p className="mb-4 text-sm mx-auto">
                    Dont have an account?
                    <a
                      href="https://athenafintech.com/contact/"
                      className="font-weight-bold ml"
                      style={{ marginLeft: '5px' , color:'#245C7F'}}
                    >
                       Contact Us
                    </a>
                  </p>
                </div>

              </div>
            </div>
            <div className="col-md-8" style={{ marginLeft: '-32px', marginRight: '-7px' }}>
              {/* <div className="oblique position-absolute h-100 d-md-block d-none me-n8">/ */}
              <div
                className="oblique-image bg-cover position-relative h-100 ms-auto"
                style={{
                  backgroundImage: `url(${process.env.PUBLIC_URL +
                    "/static/assets/img/curved-images/Artboards.png"
                    })`,
                  marginLeft: '18rem',
                  width: '116%'
                }}
              ></div>
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Login;
